export default "__VITE_ASSET__Jes0GWLt__"